export default __webpack_public_path__ + "static/media/logo.1efd9dd9.svg";